import React from 'react'

import Container from 'components/atoms/Container'
import Row from 'components/atoms/Row'
import Col from 'components/atoms/Col'

import { SVGIcon } from 'components/qstrap'
import Typography from 'components/atoms/Typography'
import LikeButton from 'components/molecules/LikeButton'
import getMajorIcon from 'utils/getMajorIcon'

import intl from 'react-intl-universal'
import triggerEvent from 'utils/dataLayer'

import { string, node, bool } from 'prop-types'

const PageBanner = ({
  title,
  subtitle,
  iconName,
  iconBg,
  content,
  imgSrc,
  likeTarget,
  likeStatus,
  kind,
}) => (
  <div className="campus-page-banner">
    <Row className="full-height">
      <Col lg="8">
        <div className="campus-page-banner__image" >
          <Container fluid>
            <div className="campus-page-banner__like-btn">
              <LikeButton
                active={likeStatus}
                kind={kind}
                targetId={likeTarget}
                variant="solid"
                className="m-y-md m-x-sm"
                complete
                forDetailPage
                useNewIcon
                handleClick={() => {
                  kind === 'professions' && triggerEvent('career_favourite', {
                    career_name: title,
                    favorite_button_location: 'top',
                    page_location: window.location.pathname,
                  })
                }}
              >
                <span className="hidden-sm-down">
                  {likeStatus ? intl.get('common.remove_from_favorite') : intl.get('common.add_to_favorite')}
                </span>
              </LikeButton>
            </div>
          </Container>
        </div>
      </Col>
      <Col lg={{ order: 'first', size: 4 }}>
        <Container className="campus-page-banner__info">
          <div className="campus-page-banner__icon">
            {kind === 'studyFields' && iconName !== 'common-course' ? getMajorIcon(iconName) : <SVGIcon size="md" name={iconName} />}
          </div>
          <Typography className="campus-page-banner__title" component="h1" variant="headline" fontWeight="bold">
            { title }
          </Typography>
          <Typography className="campus-page-banner__subheadline" component="p" variant="subheadline">
            { subtitle }
          </Typography>
          {
            content && (
              <div className="campus-page-banner__content">
                { content }
              </div>
            )
          }
        </Container>
      </Col>
    </Row>

    <style jsx>
      {`
        .campus-page-banner {
          background-color: #f6f7fa;
          @media screen and (min-width: 1024px) {
            height: 560px;
          }
          :global(.full-height, .col, &__info) {
            height: 100%;
          }
          :global(&__info) {
            padding-top: 40px;
            padding-bottom: 64px;
            @media screen and (min-width: 769px) {
              padding: ${
                content ? '80px 24px 0 80px' : '120px 24px 0 80px'
              }!important;
            }
          }
          :global(&__title) {
            margin-top: 16px !important;
            line-height: 1.5;
            color: #0c2846;
            @media screen and (min-width: 768px) {
              font-size: 24px !important;
            }
          }
          &__like-btn {
            display: flex;
            justify-content: flex-end;
          }
          &__image {
            background-image: url(${imgSrc});
            background-size: cover;
            background-position: top left;
            background-repeat: no-repeat;
            width: 100%;
            height: 100%;
            min-height: 320px;
          }
          &__icon {
            width: 64px;
            height: 64px;
            background-color: ${iconBg || '#0fc3c4'};
            border-radius: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            :global(svg) {
              fill: #fff;
            }
          }
        }
      `}
    </style>
  </div>
)

PageBanner.propTypes = {
  title: string.isRequired,
  subtitle: string,
  iconBg: string,
  iconName: string,
  content: node,
  imgSrc: string.isRequired,
  likeStatus: bool,
  likeTarget: string,
  kind: string,
}

export default PageBanner
